import React, { useEffect, useState } from 'react';
import axiosInstance from '../../AxiosInstance';
import AcceptModal from '../accept_modal';
import PreApproveModal from '../pre_approve_modal';
import RejectModal from '../reject_modal';
import ConfirmPayment from '../confirm_payment';
import ObserveModal from '../observe_modal';
import InvoiceDetailModal from '../invoice_detail';
import ObservationTextModal from '../observation_text_modal';
import CorrectionModal from '../correction_modal';
import GREViewModal from '../gre_modal';
import ConfirmDeleteModal from '../confirm_delete_modal';
import ConfirmDeleteInvoiceModal from '../confirm_delete_invoice';
import OCDetailModal from '../oc_detail';
import NECDetailModal from '../nec_modal';
import UploadModal from '../upload_modal';
import SuccessUploadModal from '../success_upload_modal';
import PurchaseOrderSettings from '../purchase_order_settings';
import RequestFinancingModal from '../request_financing';
import AcceptFinancingModal from '../accept_financing';
import ConfirmFinancingModal from '../confirm_financing';
import BillAttachmentsModal from '../bill_attachments_modal';
import { MODAL_IDS } from './modalIds';
import { useModalChannel } from './useModalChannel';
import { openNecDetail } from './modalApi';

function AcceptBillGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.acceptBill);
    if (!open || !payload?.bill) return null;
    return (
        <AcceptModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function PreApproveBillGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.preApproveBill);
    if (!open || !payload?.bill) return null;
    return (
        <PreApproveModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function RejectBillGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.rejectBill);
    if (!open || !payload?.bill) return null;
    return (
        <RejectModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function ConfirmPaymentGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.confirmPayment);
    if (!open || !payload?.bill) return null;
    return (
        <ConfirmPayment show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function ObserveBillGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.observeBill);
    if (!open || !payload?.bill) return null;
    return (
        <ObserveModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function InvoiceDetailGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.invoiceDetail);
    if (!open || !payload?.bill) return null;
    const closeDetail = () => {
        const rt = payload?.returnTo;
        close();
        if (rt) {
            openNecDetail({
                oc: rt.oc,
                nec: rt.nec,
                bill: rt.bill,
                userType: rt.userType,
            });
        }
    };
    return (
        <InvoiceDetailModal
            show={open}
            setter={(v) => { if (!v) closeDetail(); }}
            bill={payload.bill}
        />
    );
}

function ObservationTextGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.observationText);
    if (!open || payload?.text === undefined) return null;
    return (
        <ObservationTextModal show={open} setter={(v) => { if (!v) close(); }} observationText={payload.text} />
    );
}

function CorrectionBillGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.correctionBill);
    if (!open || !payload?.bill) return null;
    return (
        <CorrectionModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

function GreViewGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.greView);
    if (!open || !payload?.greData) return null;
    return (
        <GREViewModal show={open} setter={(v) => { if (!v) close(); }} data={payload.greData} />
    );
}

function ConfirmDeleteFileGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.confirmDeleteFile);
    if (!open || payload?.fileId === undefined) return null;
    return (
        <ConfirmDeleteModal show={open} setter={(v) => { if (!v) close(); }} selectedFileId={payload.fileId} />
    );
}

function ConfirmDeleteInvoiceGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.confirmDeleteInvoice);
    if (!open || !payload?.bill) return null;
    return (
        <ConfirmDeleteInvoiceModal
            show={open}
            setter={(v) => {
                if (!v) close();
            }}
            invoice={payload.bill}
            intent={payload.intent}
            returnTo={payload.returnTo}
        />
    );
}

function OcDetailGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.ocDetail);
    if (!open || !payload?.oc) return null;
    return (
        <OCDetailModal
            show={open}
            setter={(v) => { if (!v) close(); }}
            oc={payload.oc}
            userType={payload.userType}
        />
    );
}

function NecDetailGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.necDetail);
    if (!open || !payload?.oc || !payload?.nec) return null;
    return (
        <NECDetailModal
            show={open}
            setter={(v) => { if (!v) close(); }}
            oc={payload.oc}
            currentNEC={payload.nec}
            bill={payload.bill}
            userType={payload.userType}
        />
    );
}

function UploadDocumentGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.uploadDocument);
    if (!open || !payload?.oc || !payload?.nec) return null;
    return (
        <UploadModal
            show={open}
            setter={(v) => { if (!v) close(); }}
            oc={payload.oc}
            currentNEC={payload.nec}
            currentInvoiceName={payload.currentInvoiceName || ''}
            userType={payload.userType}
        />
    );
}

function SuccessUploadGate() {
    const { open, close } = useModalChannel(MODAL_IDS.successUpload);
    if (!open) return null;
    return (
        <SuccessUploadModal show={open} setter={(v) => { if (!v) close(); }} />
    );
}

function PurchaseOrderSettingsGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.purchaseOrderSettings);
    if (!open || !payload?.data) return null;
    return (
        <PurchaseOrderSettings show={open} setter={(v) => { if (!v) close(); }} data={payload.data} />
    );
}

function FinancingRequestGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.financingRequest);
    const [quoteData, setQuoteData] = useState({});

    useEffect(() => {
        if (!open || !payload?.selectedInvoice) {
            setQuoteData({});
            return;
        }
        const inv = payload.selectedInvoice;
        const clientRuc = inv.purchase_order?.client?.ruc;
        const providerRuc = inv.purchase_order?.provider?.ruc;
        const url = `financing/get_quote?amount=${encodeURIComponent(inv.total)}&seller_ruc=${encodeURIComponent(providerRuc)}&debtor_ruc=${encodeURIComponent(clientRuc)}`;
        axiosInstance.get(url).then((res) => setQuoteData(res.data)).catch(() => setQuoteData({}));
    }, [open, payload]);

    if (!open || !payload?.selectedInvoice) return null;
    return (
        <RequestFinancingModal
            show={open}
            setter={(v) => { if (!v) close(); }}
            quoteData={quoteData}
            selectedInvoice={payload.selectedInvoice}
        />
    );
}

function FinancingAcceptGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.financingAccept);
    if (!open || !payload?.selectedInvoice) return null;
    return (
        <AcceptFinancingModal show={open} setter={(v) => { if (!v) close(); }} selectedInvoice={payload.selectedInvoice} />
    );
}

function FinancingConfirmGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.financingConfirm);
    if (!open || !payload?.selectedInvoice) return null;
    return (
        <ConfirmFinancingModal
            show={open}
            setter={(v) => { if (!v) close(); }}
            quoteData={payload.quoteData || {}}
            selectedInvoice={payload.selectedInvoice}
        />
    );
}

function BillAttachmentsGate() {
    const { open, payload, close } = useModalChannel(MODAL_IDS.billAttachments);
    if (!open || !payload?.bill) return null;
    return (
        <BillAttachmentsModal show={open} setter={(v) => { if (!v) close(); }} invoice={payload.bill} />
    );
}

export default function ModalRegistry() {
    return (
        <>
            <AcceptBillGate />
            <PreApproveBillGate />
            <RejectBillGate />
            <ConfirmPaymentGate />
            <ObserveBillGate />
            <InvoiceDetailGate />
            <ObservationTextGate />
            <CorrectionBillGate />
            <GreViewGate />
            <ConfirmDeleteFileGate />
            <ConfirmDeleteInvoiceGate />
            <OcDetailGate />
            <NecDetailGate />
            <UploadDocumentGate />
            <SuccessUploadGate />
            <PurchaseOrderSettingsGate />
            <FinancingRequestGate />
            <FinancingAcceptGate />
            <FinancingConfirmGate />
            <BillAttachmentsGate />
        </>
    );
}
